import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { payslipConfigInit,
// 工资条安全配置枚举项
getPayslipConfig,
// 获取工资条安全配置
savePayslipConfig // 保存工资条安全配置
} from '@/api/payroll/pay-slip';
export default {
  data: function data() {
    return {
      options: {
        password_type: [],
        mail_type: []
      },
      formData: {
        password_type: '',
        send_app_mail_type: '',
        email_title: '',
        email_content: ''
      },
      rulesData: {
        password_type: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        send_app_mail_type: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        email_title: [{
          required: true,
          message: this.$t('90'),
          trigger: 'blur'
        }]
        // email_content: [{ required: true, message: this.$t('90'), trigger: 'blur' }]
      },

      show: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      payslipConfigInit().then(function (_ref) {
        var data = _ref.data;
        _this.options.password_type = data.password_type;
        _this.options.mail_type = data.send_app_mail_type;
      });
      getPayslipConfig().then(function (_ref2) {
        var data = _ref2.data;
        _this.formData = data;
      });
    },
    handleContent: function handleContent(val) {
      this.show = val && this.formData.email_content.length;
    },
    // 邮箱正文为空
    handleEmailCon: function handleEmailCon() {
      this.formData.email_content = '';
      this.$refs.emcon.focus();
    },
    handlerBack: function handlerBack() {
      this.$router.push('/payroll/pay-slip');
    },
    goHistory: function goHistory() {
      this.$router.push('/payroll/history-pay-slip');
    },
    sendSafePaysilp: function sendSafePaysilp() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          delete _this2.formData.id;
          savePayslipConfig({
            password_type: _this2.formData.password_type,
            send_app_mail_type: _this2.formData.send_app_mail_type,
            email_title: _this2.formData.email_title,
            email_content: _this2.formData.email_content
          }).then(function (res) {
            _this2.$message.success(res.message);
            _this2.handlerBack();
          });
        }
      });
    }
  }
};